import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

import { ENVIRONMENTS } from "./app/core/env";
import { APP_CONFIG, API_URL, ENVIRONMENT } from "./app/core/token";

fetch("/configuration/configuration.json")
	.then((response) => response.json())
	.then((config) => {
		if (config.environment === "production") {
			enableProdMode();
		}
		const envValue = ENVIRONMENTS[config.environment];

		platformBrowserDynamic([
			{ provide: APP_CONFIG, useValue: config },
			{ provide: API_URL, useValue: config.api_url },
			{ provide: ENVIRONMENT, useValue: envValue },
		])
			.bootstrapModule(AppModule)
			.catch((err) => console.error(err));
	});
